module.exports = __webpack_public_path__ + "static/media/3.09b07a5c.jpg";